import { BuildClass, Do, timer } from '../../../universal';
import { _, React } from '../../lib';
import { LoadingSpinnerSmall } from './loading';
import { CJSX, ConditionalObject } from './meta-types';
export const ButtonTW = (props) => (React.createElement(Button, { ...props, tailwind: true }));
export const Button = (props) => {
    const confirmingTimer = React.useRef(null);
    const [confirming, setConfirming] = React.useState(false);
    const type = props.type ?? 'standard';
    const style = Do(() => {
        const hidden = props.hidden ? { display: 'none' } : {};
        const all = { ...props.style, ...hidden };
        if (props.width) {
            all.minWidth = props.width;
            all.maxWidth = props.width;
            all.width = props.width;
        }
        return _.size(all) > 0 ? all : undefined;
    });
    const className = BuildClass({
        'group/ui5btn': true,
        [BuildClass({
            'ui5-btn': ['ui5-borderless-24'].includes(type),
            btnStdBorderless: type === 'borderless',
            ui5Borderless24: type === 'ui5-borderless-24',
            btnSubmit2: type === 'submit',
            btnDelete2: type === 'delete',
            btnStandard2: ['standard', 'button'].includes(type),
            btnGreenColor: type === 'green',
            btnTrans: ['trans-red', 'trans-blue'].includes(type),
            red: type === 'trans-red',
            blue: type === 'trans-blue',
            disabled: props.disabled ?? false,
            confirming: confirming,
        })]: !props.tailwind,
        [BuildClass({
            'bg-[#ddd] hover:bg-[#b9b9b9]': true,
            'border-[#aaa] hover:border-[#aaa]': true,
            'focus:border-[#333] active:border-[#333]': true,
            'border border-solid outline-0': true,
            'px-[10px] py-[5px] mx-[6px] my-[0]': true,
            'text-base leading-[19px]': true,
            'rounded-[3px] shadow-button': true,
            'active:translate-y-[2px] active:shadow-none': true,
        })]: type == 'std-tailwind',
        [BuildClass({
            'px-3 py-0 cursor-pointer rounded-[3px] bg-transparent': true,
            'border border-solid border-transparent': true,
            'opacity-50 cursor-default': props.disabled ?? false,
            'hover:bg-[#ffc] hover:border-[#aaa]': !props.disabled,
            'focus:border-[#ccc]': !props.disabled,
            'hover:shadow-[0_8px_5px_-5px_rgba(0,0,0,0.25),0_1px_2px_rgba(0,0,0,0.15),0_0_20px_rgba(0,0,0,0.05)_inset]': !props.disabled,
        })]: type == 'ui5-borderless-24',
        [BuildClass({
            'border border-solid outline-hidden rounded-[3px] appearance-none': true,
            'py-[5px] px-[10px] mx-[6px] my-0 shadow-button noncondensed': true,
            'active:shadow-none active:translate-y-[2px]': !props.disabled,
            'shadow-none translate-y-[1px] text-[#666]': props.disabled ?? false,
        })]: ['standard', 'submit', 'delete', 'green', 'button'].includes(type),
        [BuildClass({
            'bg-[#bdf] border-[#99f]': true,
            'hover:bg-[#8bf] hover:border-[#aaf]': !props.disabled,
            'focus:border-[#22f]': !props.disabled,
            'active:bg-[#88f] active:border-[#03f]': !props.disabled,
        })]: type === 'submit',
        [BuildClass({
            'bg-[#ddd] border-[#aaa]': true,
            'hover:bg-[#b9b9b9] hover:border-[#aaa]': !props.disabled,
            'focus:border-[#333]': !props.disabled,
            'active:bg-[#999] active:border-[#333]': !props.disabled,
        })]: ['standard', 'button'].includes(type),
        [BuildClass({
            'bg-[#fcc] border-[#f99]': true,
            'hover:bg-[#faa] hover:border-[#faa]': !props.disabled,
            'focus:border-[#f00]': !props.disabled,
            'active:bg-[#f88] active:border-[#f30]': !props.disabled,
        })]: type === 'delete',
        [BuildClass({
            'bg-[hsl(120,70%,80%)] border-[hsl(120,40%,55%)]': true,
            'hover:bg-[hsl(120,80%,70%)] hover:border-[hsl(120,50%,40%)]': !props.disabled,
            'focus:border-[hsl(120,100%,20%)]': !props.disabled,
            'active:bg-[#88f] active:border-[#03f]': !props.disabled,
        })]: type === 'green',
        [BuildClass({
            'outline-hidden border border-solid border-[#aaa] rounded-[3px]': true,
            'font-condensed text-[14px] uppercase tracking-[-0.2px]': true,
            'cursor-pointer transition-[border-color_background-color] duration-250': true,
        })]: ['trans-red', 'trans-blue', 'trans-green'].includes(type),
        [BuildClass({
            'bg-[#ffe5e5] border-[#fa9b9b] text-[#222]': true,
            'hover:bg-[#ff3325] hover:border-[#ff0a07] hover:text-[#fff]': !props.disabled,
        })]: type === 'trans-red',
        [BuildClass({
            'bg-[#e5e5ff] border-[#a0a0ff]': true,
            'hover:bg-[#4040ee] hover:border-[#4040ee] hover:text-[#fff]': !props.disabled,
        })]: type === 'trans-blue',
        [BuildClass({
            'bg-[#d7f0dd] border-[#7fbe8e] text-[#1f3b2b]': true,
            'hover:bg-[#2f9a4c] hover:border-[#248b43] hover:text-[#fff]': !props.disabled,
        })]: type === 'trans-green',
        'active:translate-y-[2px] active:shadow-none': !props.disabled,
        [BuildClass(props.className)]: true,
    });
    const clickEvent = React.useCallback((e) => {
        if (props.doubleClickNeeded) {
            if (!confirming) {
                setConfirming(true);
                confirmingTimer.current = timer(props.timeoutConfirmingMs ?? 2000, () => {
                    setConfirming(false);
                });
                return;
            }
            setConfirming(false);
            if (confirmingTimer.current) {
                clearTimeout(confirmingTimer.current);
            }
        }
        ;
        (props.onClick ?? _.noop)(e);
    }, [props.onClick, props.doubleClickNeeded, props.timeoutConfirmingMs, confirming]);
    return (React.createElement("button", { className: className, title: props.title ?? props.lbl, type: type === 'submit' ? 'submit' : 'button', style: style, onClick: clickEvent, ..._.omit(props, [
            'className',
            'classNameImg',
            'classNameSpan',
            'img',
            'lbl',
            'title',
            'type',
            'style',
            'onClick',
            'tailwind',
            'timeoutConfirmingMs',
            'doubleClickNeeded',
        ]) },
        ConditionalObject(props.img != null, React.createElement("img", { className: BuildClass({
                'inline align-baseline': type != 'ui5-borderless-24',
                'inline-block align-top my-[2px] mr-[3px] ml-0 h-6': type == 'ui5-borderless-24',
                'group-hover/ui5btn:opacity-100': !props.disabled && type == 'ui5-borderless-24',
                [BuildClass(props.classNameImg)]: true,
            }), src: props.img })),
        React.createElement("span", { className: BuildClass({
                'inline-block align-top text-base leading-[30px]': type == 'ui5-borderless-24',
                'font-condensed  text-[#333] uppercase': type == 'ui5-borderless-24',
                'group-hover/ui5btn:text-[#000] group-hover/ui5btn:[text-shadow:0_0_1px_#000]': !props.disabled && type == 'ui5-borderless-24',
                [BuildClass(props.classNameSpan)]: true,
            }) }, confirming ? 'Confirm?' : (props.lbl ?? props.children))));
};
export const FormButtonSet = (props) => (React.createElement("div", { className: BuildClass([
        'ui5-form-button-response',
        'tailwind-wrapper',
        props.className,
    ]) },
    React.createElement("div", { className: "buttons text-center my-[10px] p-0" },
        props.buttons &&
            props.buttons.map(btn => (React.createElement(FormButton, { key: btn.lbl, width: props.widths,
                ...btn,
                disabled: btn.disabled || props.loading }))),
        props.children &&
            React.Children.map(props.children, x => {
                if (x == null) {
                    return x;
                }
                if (x.type != FormButton) {
                    throw new Error('Invalid child type to FormButtons');
                }
                return React.cloneElement(x, {
                    width: x.props.width ?? props.widths,
                    disabled: x.props.disabled || props.loading,
                });
            })),
    React.createElement(CJSX, { cond: !props.hideFeedbackLine },
        React.createElement("div", { role: "status", "aria-live": "polite", className: BuildClass({
                lblResponse: true,
                'text-center min-h-[20px] leading-[20px]': true,
                'text-[#060]': Boolean(props.good || props.tick) && !props.neutral,
                'text-[#f00]': !props.good && !props.tick && !props.neutral,
                'text-[#666]': Boolean(props.neutral) && !props.good,
            }) }, Do(() => {
            if (props.tick) {
                return (React.createElement("img", { className: "inline", src: "/static/img/tick.png", alt: "Success!" }));
            }
            else if (props.loading) {
                return React.createElement(LoadingSpinnerSmall, null);
            }
            else if (_.isArray(props.msg)) {
                return (React.createElement("div", null, props.msg.map((v, k) => (React.createElement("div", { key: k }, v)))));
            }
            else if (!props.msg) {
                return React.createElement("div", null);
            }
            return React.createElement("div", null, props.msg);
        })))));
export const FormButton = (props) => {
    if (props.hidden ?? false) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Button, { className: BuildClass({
            'min-w-[120px]': props.width == null,
            [BuildClass(props.className)]: true,
        }), autoFocus: props.autoFocus, classNameSpan: props.classNameSpan, width: props.width, type: props.type ?? guessButtonTypeFromLabel(props.lbl.toLowerCase()), disabled: props.disabled, onClick: props.onClick, title: props.title, lbl: props.lbl, style: props.style }));
};
const submits = ['save', 'submit', 'go', 'login', 'sign in', 'add', 'verify', 'send'];
const standards = ['reset', 'cancel', 'undo', 'reorder'];
const deletes = ['delete', 'ignore', 'remove'];
const guessButtonTypeFromLabel = (lbl) => {
    if (submits.includes(lbl)) {
        return 'submit';
    }
    else if (standards.includes(lbl)) {
        return 'standard';
    }
    else if (deletes.includes(lbl)) {
        return 'delete';
    }
    return 'standard';
};
export const AddButton = (props) => (React.createElement(Button, { lbl: props.lbl ?? 'Add', title: props.title, type: props.type ?? 'ui5-borderless-24', img: props.icon ?? '/static/img/i8/w11-add.svg', onClick: props.onClick, className: props.className, disabled: props.disabled }));
//# sourceMappingURL=buttons.js.map